module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray-c7b5200f22f8038a91759704307bf585.png";